import GlobalEvents from "base/GlobalEvents";
import {EVENT_GLOBAL_ATTACH} from "base/FormValidator";

GlobalEvents.on(EVENT_GLOBAL_ATTACH, (validator) => {
    validator.on('input:showMessage', (data) => {
        data.input.$input.closest('.gfield').addClass('gfield_error');
    }).on('input:hideMessage', (data) => {
        data.input.$input.closest('.gfield').removeClass('gfield_error');
    });
});